export const customDateFormat = (date: string) => {
  const tempLastUpdateDate = new Date(date);
  const day = tempLastUpdateDate.getDate() < 10 ? `0${tempLastUpdateDate.getDate()}` : tempLastUpdateDate.getDate();
  const month = tempLastUpdateDate.getMonth() + 1 < 10 ? `0${tempLastUpdateDate.getMonth() + 1}` : tempLastUpdateDate.getMonth() + 1;
  const year = tempLastUpdateDate.getFullYear();

  return `${day}.${month}.${year}`;
}